import { imgAssets } from '@utils/img-assets';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { FC, ReactNode } from 'react';
import TakeMeHomeBtn from './TakeMeHomeBtn';

type ErrorMessageProps = {
  title?: string;
  description?: string;
  imgSrc?: string;
  imgAlt?: string;
  imgWidth?: number;
  imgHeight?: number;
  actionBtn?: ReactNode;
};

const ErrorMessage: FC<ErrorMessageProps> = ({
  imgSrc = imgAssets.personas.sadBartender,
  imgAlt = 'Error Illustration',
  imgWidth = 192,
  imgHeight = 192,
  title,
  description,
  actionBtn = <TakeMeHomeBtn />
}) => {
  const t = useTranslations('error');
  const titleIntl = title || t('title');
  const descriptionIntl = description || t('description');

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] p-6">
      <div className="relative flex flex-col-reverse md:flex-row items-center gap-8 max-w-2xl mx-auto">
        <Image
          src={imgSrc}
          alt={imgAlt}
          width={imgWidth}
          height={imgHeight}
          className="w-36 h-36 md:w-48 md:h-48 rounded-full z-10"
        />

        <div className="relative bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg w-full md:max-w-md">
          <div className="hidden md:block absolute left-0 top-1/2 -translate-x-2 -translate-y-1/2">
            <div className="w-4 h-4 bg-white dark:bg-gray-800 transform rotate-45" />
          </div>

          <div className="md:hidden absolute bottom-0 left-1/2 translate-y-2 -translate-x-1/2">
            <div className="w-4 h-4 bg-white dark:bg-gray-800 transform rotate-45" />
          </div>

          <div className="flex flex-col gap-4 text-gray-600 dark:text-gray-300">
            <div className="flex items-center gap-2">
              <h2 className="text-lg font-semibold">{titleIntl}</h2>
            </div>

            <p className="text-sm text-gray-400">{descriptionIntl}</p>
            {actionBtn}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;
